import { styled } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { IAppDrawer } from "./AppDrawerInterfaces";
import AppToolbar from "./components/AppToolbar/AppToolbar.view";

// Cedar rebrand: the persistent side drawer was removed. Navigation now lives in
// the top bar (logo upper-left, Locations dropdown + Languages + user menu on the
// right), so this component is just the frosted full-width AppBar.
const AppBar = styled(MuiAppBar)(({ theme }) => ({
    backgroundColor: "rgba(255, 255, 255, 0.94)",
    backdropFilter: "blur(10px)",
    color: theme.palette.menu.icons.main,
    borderBottom: `1px solid ${theme.palette.border.select}`,
}));

const AppDrawer = ({ appDrawerItems, navLabel }: IAppDrawer) => {
    return (
        <AppBar position="fixed" elevation={0}>
            <AppToolbar appDrawerItems={appDrawerItems} navLabel={navLabel} />
        </AppBar>
    );
};

export default AppDrawer;
